// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__3yC_R"};